export default __webpack_public_path__ + "static/media/26ec3886f9c4f57f.f86485995b70442cb78738a339e50f3a.svg";